var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "inherit",
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99976 4.76226L0.805116 0.339347C0.763254 0.302933 0.713554 0.274144 0.658892 0.254647C0.60423 0.23515 0.545692 0.225332 0.486665 0.22576C0.427638 0.22619 0.369295 0.236857 0.315011 0.257146C0.260727 0.277435 0.21158 0.306942 0.170415 0.343961C0.12925 0.380979 0.0968833 0.424772 0.0751888 0.472808C0.0534943 0.520844 0.0429023 0.572167 0.044026 0.623808C0.0451496 0.675449 0.0579665 0.726382 0.0817349 0.77366C0.105503 0.820939 0.139751 0.863622 0.182497 0.899242L5.68845 5.58674C5.77179 5.65769 5.88348 5.69739 5.99976 5.69739C6.11604 5.69739 6.22773 5.65769 6.31107 5.58674L11.817 0.899242C11.8598 0.863622 11.894 0.820938 11.9178 0.77366C11.9416 0.726382 11.9544 0.675449 11.9555 0.623808C11.9566 0.572167 11.946 0.520843 11.9243 0.472807C11.9026 0.424772 11.8703 0.380978 11.8291 0.34396C11.7879 0.306942 11.7388 0.277435 11.6845 0.257146C11.6302 0.236857 11.5719 0.226189 11.5129 0.22576C11.4538 0.225331 11.3953 0.235149 11.3406 0.254646C11.286 0.274144 11.2363 0.302932 11.1944 0.339347L5.99976 4.76226Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow);
export default __webpack_public_path__ + "static/media/row.1641c25ab5daa5432cd8d94392e1ec3c.svg";
export { ForwardRef as ReactComponent };